import { escapeHtml } from './strings';

export const printSvg = ({ title, svgMarkup }: { title: string; svgMarkup: string }) => {
  const printWindow = window.open('', '_blank', 'width=600,height=700');
  if (!printWindow) {
    return false;
  }

  printWindow.document.write(`<!DOCTYPE html>
<html>
<head>
  <title>${escapeHtml(title)}</title>
  <style>
    @page { margin: 0; }
    body { margin: 0; padding: 64px 40px; font-family: sans-serif; text-align: center; }
    h1 { font-size: 24px; margin: 0 0 32px; }
    .qr { display: inline-block; }
  </style>
</head>
<body>
  <h1>${escapeHtml(title)}</h1>
  <div class="qr">${svgMarkup}</div>
  <script>window.onload = () => { window.print(); };</script>
</body>
</html>`);
  printWindow.document.close();
  return true;
};
